import store from '../../store/index'
import i18n from '@/plugins/i18n'
import { showError } from '../Mensaje'

export function getMensajeInternacionalizado(codigo, parametros) 
{
  let mensaje = ''

  // obtengo el idioma seleccionado en el UX
  let idioma = i18n.locale.toUpperCase()

  // obtengo los mensajes del app store de vuex
  let listaMensajes = store.state.app.mensajes || []
  
  // obtengo el mensaje en el idioma seleccionado
  let mensajeInternacionalizado = listaMensajes.find((x) => { if(x.Id == codigo && x.Idioma == idioma) return x })
  if(mensajeInternacionalizado !== undefined)
  {
    mensaje = mensajeInternacionalizado.Mensaje
  }
  else
  {
    var errorCode = codigo.CodigoResultado!==undefined?codigo.CodigoResultado:codigo;
    // busco el error en el archivo de recursos (i18n)
    let idError = `ERROR_CODE_${errorCode}`
    mensaje = i18n.messages[i18n.locale][idError]
    
    // si no se encontró el mensaje...
    if(mensaje === undefined)
    {
      // muestro un mensaje genérico
      console.log(`Código de error no encontrado: ${codigo}`)
      mensaje = getMensajeNoEncontrado(idioma)
    }
  }

  if(parametros !== undefined && parametros !== null && String(parametros).trim() !== '')
    mensaje = mensajeInternacionalizado !== undefined
      ? `${mensaje} ${parametros}`
      : `${mensaje}. DETALLE: ${parametros}`

  return mensaje
}

export function mostrarMensajeInternacionalizado(codigo, parametros) 
{
  let mensaje = getMensajeInternacionalizado(codigo, parametros)

  // muestro el mensaje de error
  showError(mensaje)
}

// muestra el error de un ResultadoOperacion de Garantías (CodigoResultado / DescripcionResultado):
// la descripción ya es el mensaje para el usuario; si viene vacía se usa el mensaje del código o uno genérico
export function mostrarResultadoOperacion(resultado)
{
  const descripcion = resultado && resultado.DescripcionResultado
  if(descripcion !== undefined && descripcion !== null && String(descripcion).trim() !== '')
  {
    showError(descripcion)
    return
  }

  const codigo = resultado && resultado.CodigoResultado !== undefined ? resultado.CodigoResultado : -1
  mostrarMensajeInternacionalizado(codigo)
}

function getMensajeNoEncontrado(idioma) 
{
  switch(idioma) 
  {
    case "ES":
      return "Se produjo un error inesperado"
    case "EN":
      return "An error has ocurred"
    default:
      return "ERROR"
  }
}